module.exports = __webpack_public_path__ + "img/news2.8cf84c3e.png";